import React from 'react';
import BankAccountV1 from 'pages/AccountSetting/BankAccount';
import BankAccountV2 from 'pages/AccountSetting/BankAccountV2';
import withFeatureFlags from 'hocs/withFeatureFlags';

function BankAccount(props) {
  const { useNewUi } = props;

  return useNewUi ? <BankAccountV2 /> : <BankAccountV1 />;
}

function mapFlagsToProps(flags) {
  return {
    useNewUi: flags.multipleBankAccountV2,
  };
}

export default withFeatureFlags(mapFlagsToProps)(BankAccount);
